import { useCallback } from 'react';
import { useAppSelector, useAppDispatch } from 'store/hooks/useStore';
import {
  menuDetailActions,
  menuDetailSelectors,
} from 'store/reducers/menuCategoryReducer/menuDetailSlice';
import { listActions } from 'store/reducers/menuCategoryReducer/listSlice';
import { useToast } from 'hooks/useToast';
import * as menuApi from 'api/menuApi';
import { loaderActions } from 'store/reducers/loaderReducer/loaderSlice';
import { useListStore } from './useListStore';
import { mapMenuToFormFields } from '../types/menuEditFormFields';

export const useMenuDeleteStore = () => {
  const dispatch = useAppDispatch();
  const toast = useToast();
  const { fetchMenuCategories } = useListStore();
  const selectedMenu = useAppSelector(menuDetailSelectors.selectedMenu);
  const isOpenModal = useAppSelector(menuDetailSelectors.isOpenModalDelete);

  const onCloseModal = useCallback(() => {
    dispatch(menuDetailActions.updateIsOpenModalDelete(false));
  }, [dispatch]);

  const onDeleteMenu = useCallback(() => {
    if (selectedMenu) {
      const requestDelete = async () => {
        dispatch(loaderActions.setLoading(true));
        dispatch(menuDetailActions.updateLoadingStatus(true));
        const result = await menuApi.deleteMenu(selectedMenu.id);
        if (result.ok) {
          toast({
            status: 'success',
            description: `メニューを削除しました。`,
          });

          onCloseModal();
          dispatch(listActions.deleteMenuSuccess({ menuId: selectedMenu.id }));
          dispatch(menuDetailActions.modalOpened(null));
          void fetchMenuCategories();
        } else {
          toast({
            status: 'error',
            description: `メニューの削除に失敗しました。`,
          });
        }
        dispatch(menuDetailActions.updateLoadingStatus(false));
        dispatch(loaderActions.setLoading(false));
      };

      requestDelete().catch(() => {
        toast({
          status: 'error',
          description: `メニューの削除に失敗しました。`,
        });
      });
    }
  }, [selectedMenu, toast, dispatch, onCloseModal, fetchMenuCategories]);

  return {
    /** メニューの内容 */
    values: mapMenuToFormFields(selectedMenu || {}, {}),
    /** メニューの削除 */
    onDeleteMenu,
    /** メニューの削除キャンセル */
    onCloseModal,
    /** メニュー削除確認モーダルの表示状態 */
    isOpenModal,
  };
};
